export { ClipboardModule, ClipboardDirective } from './src/index';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-clipboard/dist/index.js
// module id = 1083
// module chunks = 4